import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContentCard from '@/components/feature/ContentCard';
import { SectionHeader } from '@/components/feature/SectionHeader';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import { FEATURED_CONTENT, LATEST_CONTENT, TOP_RATED_CONTENT } from '@/mocks';

export default function Home() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <SchemaOrg type="Organization" data={{
        name: '777影院',
        url: 'https://777cinema.com',
        description: '777影院午夜伦不卡提供电影、电视剧、综艺等在线观看，高清画质，流畅不缓冲，免费看全集，极速播放体验。',
        sameAs: ['https://weibo.com/777cinema'],
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '777影院',
        url: 'https://777cinema.com',
        description: '777影院午夜伦不卡 — 电影电视剧全集在线观看高清不缓冲',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://777cinema.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '777影院 - 首页',
        description: '777影院午夜伦不卡提供电影、电视剧、综艺等在线观看，高清画质，流畅不缓冲。',
        url: 'https://777cinema.com',
        isPartOf: { '@type': 'WebSite', name: '777影院', url: 'https://777cinema.com' },
      }} />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main>
          <HeroBanner />
          <CategoryNav />

          <section className="px-4 md:px-6 pt-10 md:pt-14" aria-labelledby="featured-heading">
            <div className="max-w-[1440px] mx-auto">
              <SectionHeader
                title="热门推荐"
                subtitle="编辑精选，不容错过的口碑佳作"
                moreLink="/category/dianying"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
                {FEATURED_CONTENT.map((item) => (
                  <div key={item.id} onClick={scrollToTop}>
                    <ContentCard item={item} />
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 pt-10 md:pt-14" aria-labelledby="latest-heading">
            <div className="max-w-[1440px] mx-auto">
              <SectionHeader
                title="最新更新"
                subtitle="每日24小时不间断更新，精彩不错过"
                moreLink="/category/dianshiju"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
                {LATEST_CONTENT.map((item) => (
                  <div key={item.id} onClick={scrollToTop}>
                    <ContentCard item={item} />
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 pt-10 md:pt-14 pb-14 md:pb-20" aria-labelledby="top-rated-heading">
            <div className="max-w-[1440px] mx-auto">
              <SectionHeader
                title="高分佳作"
                subtitle="豆瓣高分经典，口碑炸裂不容错过"
                moreLink="/category/dianying"
                moreText="更多高分"
              />
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
                {TOP_RATED_CONTENT.map((item) => (
                  <div key={item.id} onClick={scrollToTop}>
                    <ContentCard item={item} />
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}